import { render } from "./ProfileEditFormPanel.vue?vue&type=template&id=36819d11&scoped=true"
import script from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanel.vue?vue&type=style&index=0&id=36819d11&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36819d11"]])

export default __exports__